/* 
 * Export component file to be used on project
*/

import NotificationStep from './NotificationStep.js';
export default NotificationStep;
